/******************************************************************************************
 *	Add Team Members Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.addTeamMembersModal', [])
    .factory(
      'AddTeamMembersModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/add-team-members-modal.html',
          controller: 'AddTeamMembersModalController',
          classNames: 'add-team-members-modal'
        });
      }
    )
    .controller(
      'AddTeamMembersModalController',
      /* @ngInject */
      function(_, $log, $scope, Utility, AddTeamMembersModal, TeamMembers, CurtainNotifications) {
        //Array of strings made up of splitting user input string by comma.
        $scope.emailsArray = [];

        $scope.duplicateEmailIsPresent = false;
        $scope.isEmailValid = null;

        //Validation function, returns true if input is valid, false otherwise
        $scope.isValid = function() {
          var valid = true;
          $scope.duplicateEmails = []; //Reset duplicate emails array

          var input = $scope.emailsString;
          if (input) {
            //Clean input by removing all spaces and all successsive commas with a single comma and also any starting and ending commas
            input = _(input)
              .replace(/\s*/g, '')
              .replace(/,{2,}/g, ',')
              .replace(/^,|,$/g, '');

            //Split input by comma
            $scope.emailsArray = _.split(input, ',');

            //Remove duplicate entries
            $scope.emailsArray = _.uniq($scope.emailsArray);

            //Parse the obtained array, cleaning and validating each item
            var count = $scope.emailsArray.length;
            if (count < 1) {
              valid = false;
            } else {
              for (var i = 0; i < count; i++) {
                //Validate emails.
                if (!Utility.isValidEmail($scope.emailsArray[i])) {
                  valid = false;
                }
                //Check for duplicate emails.
                if (_.includes($scope.memberEmails, $scope.emailsArray[i])) {
                  valid = false;

                  //Check if it's not already in the list
                  if (!_.includes($scope.duplicateEmails, $scope.emailsArray[i])) {
                    $scope.duplicateEmails.push($scope.emailsArray[i]);
                  }
                }
              }
            }
          } else {
            valid = false;
          }

          $scope.duplicateEmailIsPresent = Boolean($scope.duplicateEmails.length);
          $scope.invalidInput = !valid;
          return valid;
        };

        //Submit
         $scope.resetSubmit = function() {
          AddTeamMembersModal.unsetLoadingState();
          $scope.submitted = false;

          // Reset email validity 
          $scope.isEmailValid = null;
        };

        $scope.submit = function() {
          //Reset showInvitationsFailedError if it was set to true previously
          $scope.showInvitationsFailedError = false;

          if ($scope.isEmailValid === null) {
            $scope.isEmailValid = $scope.isValid();
          }

          if (!$scope.submitted && $scope.isEmailValid) {
            $scope.submitted = true;
            AddTeamMembersModal.setLoadingState();

            //POST call
            TeamMembers.invite($scope.emailsArray)
              .then(function(responseData) {
                if (responseData.failed && responseData.failed.length) {
                  //Set text area value to be the list of failed emails
                  $scope.emailsString = responseData.failed.join(', ');
                  $scope.showInvitationsFailedError = true;

                  // Save the invites that were successfully sent so we can update the team when
                  // the dialog closes.
                  if (responseData.created) {
                    if (!$scope.partialCreated) {
                      $scope.partialCreated = [];
                    }
                    Array.prototype.push.apply($scope.partialCreated, responseData.created);
                  }

                  CurtainNotifications.show(
                    CurtainNotifications.NOTICE,
                    'addTeamMemberModal.notifications.submitPartialSuccess'
                  );
                  $scope.resetSubmit();
                } else {
                  var message;
                  if ($scope.emailsArray.length === 1) {
                    message = 'addTeamMemberModal.notifications.submitSuccessSingular';
                  } else {
                    message = 'addTeamMemberModal.notifications.submitSuccessPlural';
                  }

                  CurtainNotifications.show(CurtainNotifications.SUCCESS, message);

                  // If a partial success occurred prior to this one, 'partialCreated' will contain an
                  // Array of invites successfully sent. The display should be updated with these invites.
                  AddTeamMembersModal.remove({
                    response: responseData,
                    partialCreated: $scope.partialCreated
                  });
                }
              })
              .catch(function(response) {
                $log.warn(response.data, response.status);
                if (response.status !== 0) {
                  //status is 0 when call is aborted
                  //Get first character from HTTP status as number
                  var statusType = +('' + response.status).charAt(0);

                  if (statusType === 4) {
                    //Duplicate email addresses
                    if (response.status === 409) {
                      if (_.get(response, 'data.duplicate.length')) {
                        //Set duplicate emails to display in view
                        $scope.duplicateEmails = response.data.duplicate;

                        //Also add them to the list of member emails
                        _.forEach(response.data.duplicate, function(item) {
                          //Check if it's not already in the list
                          if (!_.includes($scope.memberEmails, item)) {
                            $scope.memberEmails.push(item);
                          }
                        });
                      }

                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'addTeamMemberModal.notifications.submitErrorDuplicateEmails'
                      );
                    } else if (response.status === 418) {
                      //Server failed to send at least one invitations, hence its a teapot.
                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'generic.notifications.error'
                      );
                    } else {
                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'generic.notifications.error'
                      );
                    }

                    $scope.resetSubmit();
                    $log.error('Failed to invite team members', response.data);
                  }
                }
              });
          } else {
            $scope.resetSubmit();
          }
        };

        //Close modal
        $scope.removeModal = function() {
          // Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object
          // containing a true `cancelled` property
          // If a partial success occurred prior to the modal cancellation, 'partialCreated' will contain
          // an Array of invites successfully sent. The display should be updated with these invites.
          AddTeamMembersModal.remove({
            cancelled: true,
            partialCreated: $scope.partialCreated
          });
        };
      }
    );
})();
